<template>
  <div>
    <div class="application8">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application8-1.jpg" alt />
          <img src="../../assets/images/application/application8-2.jpg" alt />
          <img src="../../assets/images/application/application8-3.jpg" alt />
          <img src="../../assets/images/application/application8-4.jpg" alt />
          <img src="../../assets/images/application/application8-5.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application8">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>智慧产业园、智慧创业园、智慧建筑运维、智慧化工园区、智慧高速公路服务区、智慧物流园区等。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>建立基于BIM、GIS、VR可视化技术和物联网技术的精细化运营管理平台。以运营数据管理平台为数据支撑，通过三维场景展示3DGIS和建筑BIM模型，同时将3DGIS、BIM模型管理、流程管理、设备资产管理、3DGIS、BIM运营维护管理、能源管理、物业管理、安防管理、应急管理等功能模块叠加在3DGIS、BIM模型上，通过三维可视化的方式向管理人员提供直观的管理手段。采用大数据、人工智能分析技术，为运营优化提供数据预测、支持和决策参考，提升精细化运营管理质量，降低运营成本。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 5" :key="index">
              <img :src="getImg(`application8-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application8",
  metaInfo: {
    title: "智慧城管系统_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "城市网格化,城管GIS,精细化管理"
      },
      {
        name: "description",
        content:
          "数字化城管模式,是现代化城市管理的一种新模式,是把城市管理和信息技术融合在一起如GIS、移动APP、物联网等,采用网格划分和事件管理、部件管理等方式,对管理对象进行标准化,对管理流程再造和创新。通过建立数字化城市管理平台,解决职能交叉、信息滞后等在传统城市管理模式中存在的问题。使城市管理向精细化、服务型转变。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧城管系统",
        p:
          "数字化城管模式，是现代化城市管理的一种新模式，是把城市管理和信息技术融合在一起如GIS、移动APP、物联网等，采用网格划分和事件管理、部件管理等方式，对管理……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "城市网格化、城管信息化、街道精细化管理应用。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "数字化城管模式，是现代化城市管理的一种新模式，是把城市管理和信息技术融合在一起如GIS、移动APP、物联网等，采用网格划分和事件管理、部件管理等方式，对管理对象进行标准化，对管理流程再造和创新。通过建立数字化城市管理平台，解决职能交叉、信息滞后等在传统城市管理模式中存在的问题。使城市管理向精细化、服务型转变。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application8 {
  font-size: 0;
  img {
    width: 584px;
    margin-bottom: 20px;
    &:nth-child(1),
    &:nth-child(3) {
      width: 584px;
      margin-right: 20px;
    }
    &:nth-child(5) {
      margin-bottom: 0;
      width: 100%;
    }
  }
}
.mobile-application8 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application8 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application8 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application8.vue